import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { protectedRoute } from "@/lib/protectedRoute";
import { Visits } from "@/pages/Visits";

export const Route = createFileRoute("/visits/")({
  component: Visits,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
  validateSearch: z.object({
    openNewVisit: z.coerce.boolean().optional(),
    // Pre-chart sheet (VITE_PRE_CHART_ENABLED), from the sidebar or phones.
    openPreChart: z.coerce.boolean().optional(),
    // EMR launch link template (already sanitized by /launch).
    template: z.string().optional().catch(undefined),
  }),
});
